<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="userId" >
        <span slot="label" >
          <a-tooltip>
            用户id<template slot="title">用户id</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.userId"  :placeholder="$t('请输入')+'用户id'" />
      </a-form-model-item>
      <a-form-model-item prop="type" >
        <span slot="label" >
          <a-tooltip>
            账户类型，1:paypal，2: 银行卡<template slot="title">账户类型，1:paypal，2: 银行卡</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="realName" >
        <span slot="label" >
          <a-tooltip>
            持卡人姓名<template slot="title">持卡人姓名</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.realName" :maxLength="256" :placeholder="$t('请输入')+'持卡人姓名'" />
      </a-form-model-item>
      <a-form-model-item prop="backName" >
        <span slot="label" >
          <a-tooltip>
            银行名称<template slot="title">银行名称</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.backName" :maxLength="256" :placeholder="$t('请输入')+'银行名称'" />
      </a-form-model-item>
      <a-form-model-item prop="backCardNo" >
        <span slot="label" >
          <a-tooltip>
            银行卡号<template slot="title">银行卡号</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.backCardNo" :maxLength="128" :placeholder="$t('请输入')+'银行卡号'" />
      </a-form-model-item>
      <a-form-model-item prop="openBankName" >
        <span slot="label" >
          <a-tooltip>
            开户行<template slot="title">开户行</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.openBankName" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="routingNumber" >
        <span slot="label" >
          <a-tooltip>
            routing number<template slot="title">routing number</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.routingNumber" :maxLength="64" :placeholder="$t('请输入')+'routing number'" />
      </a-form-model-item>
      <a-form-model-item prop="swiftCode" >
        <span slot="label" >
          <a-tooltip>
            swift code<template slot="title">swift code</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.swiftCode" :maxLength="32" :placeholder="$t('请输入')+'swift code'" />
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            备注<template slot="title">备注</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getUnionWithdrawalAccount, addUnionWithdrawalAccount, updateUnionWithdrawalAccount } from '@/api/union/unionWithdrawalAccount'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        type: null,

        realName: null,

        backName: null,

        backCardNo: null,

        openBankName: null,

        routingNumber: null,

        swiftCode: null,

        createTime: null,
        localeFieldMap:{},

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用户id'+this.$t('不能为空'), trigger: 'blur' }
        ],
        type: [
          { required: true, message: '账户类型，1:paypal，2: 银行卡'+this.$t('不能为空'), trigger: 'change' }
        ],
        realName: [
          { required: true, message: '持卡人姓名'+this.$t('不能为空'), trigger: 'blur' }
        ],
        backName: [
          { required: true, message: '银行名称'+this.$t('不能为空'), trigger: 'blur' }
        ],
        backCardNo: [
          { required: true, message: '银行卡号'+this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        type: null,
        realName: null,
        backName: null,
        backCardNo: null,
        openBankName: null,
        routingNumber: null,
        swiftCode: null,
        createTime: null,
        localeFieldMap:{},
        remark: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getUnionWithdrawalAccount({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateUnionWithdrawalAccount(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addUnionWithdrawalAccount(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
